
document.addEventListener('click', async function(event) {
  const button = event.target.closest('.ml-special-coupon__copy');
  if (!button) return;

  const coupon = button.closest('.ml-special-coupon');
  const input = coupon?.querySelector('.ml-special-coupon__code');
  const message = coupon?.querySelector('.ml-special-coupon__copy-message');

  if (!input) return;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(input.value);
    } else {
      input.focus();
      input.select();
      if (!document.execCommand('copy')) {
        throw new Error('Copy failed');
      }
    }

    button.textContent = 'コピーしました ✓';

    if (message) {
      message.style.display = 'block';
    }

    setTimeout(function() {
      button.textContent = 'コピーする';
      if (message) message.style.display = 'none';
    }, 3000);

  } catch (error) {
    if (message) {
      message.textContent = 'コピーできませんでした。コードを手動でコピーしてください。';
      message.style.display = 'block';
    }
  }
});
